export default "__VITE_ASSET__5d74454c__"